import EcologicallyAppropriate from "../assets/files/restoration/ecologically_appropriate_fire.pdf";
import SoilHealth from "../assets/files/restoration/soil_health_unseen_biodiversity.pdf";
import StableCommunities from "../assets/files/restoration/stable_communitites.pdf";
import WhatIsANativePlant from "../assets/files/restoration/what_is_a_native_plant.pdf";
import WhatIsEcological from "../assets/files/restoration/what_is_ecological_restoration.pdf";
import WhyDoWeThink from "../assets/files/restoration/why_do_we_think_what_we_think.pdf";
import Sustaining from "../assets/files/restoration/SustainingOurNaturalHeritage.pdf";
import Stewardship from "../assets/files/restoration/stewardship_and_monitorying.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const RestorationList: EssayType[] = [
  {
    name: "Ecologically Appropriate Fire",
    file: EcologicallyAppropriate,
  },
  {
    name: "Soil Health: The Unseen Biodiversity",
    file: SoilHealth,
  },
  {
    name: "Stable Communities",
    file: StableCommunities,
  },
  {
    name: "What is a Native Plant?",
    file: WhatIsANativePlant,
  },
  {
    name: "What is Ecological Restoration?",
    file: WhatIsEcological,
  },
  {
    name: "Why Do We Think What We Think?",
    file: WhyDoWeThink,
  },
  {
    name: "Sustaining Restoration",
    file: Sustaining,
  },
  {
    name: "Stewardship and Monitoring",
    file: Stewardship,
  },
];

export default RestorationList;
export type { EssayType };
